import React from 'react';
import { useNavigate } from 'react-router-dom';

const VerificationErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="questionnaire-page">
      <div className="page-header">
        <div className="page-info">
          <h2>Verification Failed</h2>
          <p className="page-description">
            The verification code you provided is invalid or has expired.
          </p>
        </div>
      </div>

      <div className="questions-container">
        <div className="question-block no-hover">
          <div className="error-message">
            <h3>Code Validation Failed</h3>
            <p>Please contact your organization administrator for a new verification code.</p>
          </div>

          <div className="auth-links">
            <button 
              className="link-button"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationErrorPage;
